import functions from "../../Data/Functions"

// Define Variable names for all the arrays
let PlayerAccred, PlayerAccreds, StaffAccredids, OfficialAccredids, NBL1Associations, mediaAccred, Finals

export default {
    LoadBQRegoLink: (Association) => {
        switch (Association) {
            case 180:   // Brisbane
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=aa9f1534-73c7-4619-a69d-e18bc4e57143&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=41847eecd919fd87b77ef1d9d229b930'
                break;
            case 183:   // Cairns
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=fe7be972-0e98-40ae-888b-3a133bcf2e42&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=42cd876f859f7ef0b04877255768ac18'
                break;
            case 185:   // Gold Coast
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=beaee088-ad3e-4758-b367-f470f6422c7a&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=333ebf11b3c9c18d4741ae7285cb0404'
                break;
            case 186:   // Ipswich
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=850f737a-0475-4990-b9cd-e83de951530a&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=d4a3de680a8a3bd80b2c8e025886c47e'
                break;
            case 176:   // Logan
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=d9e68e33-0b4b-4da7-8fb7-ca28933f0bd7&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=a7e99e13011cfd5bb5febed7b7831535'
                break;
            case 187:   // Mackay
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=43002dea-7061-40cb-8c75-68c456364dde&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=e593ec2741052cff703f3cf635b15437'
                break;
            case 175:   // North Gold Coast
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=5087b0e9-b0cd-494c-be2a-f470b0cd554f&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=8cb48abb530174e5bc1334a32b3157d9'
                break;
            case 188:   // Northside
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=155fb981-71f6-48a0-a53f-1da7ee78fb39&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=0e768f4640d484adcd58347af20c1b37'
                break;
            case 189:   // Rocky
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=dc3a9ce8-1dc0-4b25-8be9-496413f70b0b&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=5d2a33a97fc2da0bc8d3705ebbb6fdd0'
                break;
            case 177:   // South West
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=8d56a05f-8b53-44e8-a6fd-7b431c38ad51&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=3bbfb230a0ce1ccdb6f404428a38fac8'
                break;
            case 179:   // Sth Districts
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=75a115f4-90b6-461b-a3a5-aa0b9ce99f7a&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=c21ad83e2cb561dc86ec0927b4895da6'
                break;
            case 192:   // Phoenix
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=21306433-ce41-4007-b61a-d9af2e82984f&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=76e5a70d467f9d882d33eabd2e29316f'
                break;
            case 194:   // Townsville
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=a81a7a9f-7f73-4be3-96eb-ea5913824727&competitionId=245aed0f-e350-40b2-9f2c-9ab8bc834f98&key=5667d53b0c9392760de7ce32bdb10f89'
                break;

            default:
                break;
        }
    },

    // Load all external Forms for each Conference
    LoadExtForm: (form, conf) => {

        switch (conf) {
            // NBL1 South
            case 3031:
                if (form == 'COC') {
                    return "https://nbl1.basketball/imgArticles/NBL1_South_Codes_of_Conduct.pdf"
                }
                if (form == 'COVID') {
                    return "https://www.basketballvictoria.com.au/resources/association-resources/covid-19#return-to-sport-update-29-november"
                }
                if (form == 'T&Cs') {
                    return "https://www.basketballvictoria.com.au/about/about-us/terms"
                }
                if (form == 'Uniform') {
                    return 'https://nbl1.basketball/imgArticles/BIGV_Uniforms.jpg'
                }
                if (form == 'U16') {
                    return 'https://nbl1.basketball/Documents/Age_Indemnification_Form.pdf'
                }
                if (form == 'Concussion') {
                    return 'https://nbl1.basketball/Other_Documents/NBL1_South_Concussion_Policy.pdf'
                }


                break;
            // NBL1 North
            case 3034:
                if (form == 'COC') {
                    return "https://assets-global.website-files.com/645c37312e4131ceca6d3887/6461903dbf7e8d2d4187eea8_BQ-Codes-of-Behaviour.pdf"
                }
                if (form == 'COVID') {
                    return "https://queensland.basketball/BQCOVIDResourceHub.html"
                }
                if (form == 'T&Cs') {
                    return "https://nbl1.basketball/Documents/NBL1North2024RulesV2.pdf"
                }
                if (form == 'Uniform') {
                    return 'https://www.queensland.basketball/about/annual-reports#BA-integrity'
                }
                if (form == 'U16') {
                    return 'https://www.queensland.basketball/about/annual-reports#BA-integrity'
                }
                if (form == 'Concussion') {
                    return 'https://nbl1.basketball/Documents/BA-Concussion-Guidelines-Harcourt-FINAL.pdf'
                }
                break;
            // NBL1 West
            case 3033:
                if (form == 'COC') {
                    return "https://www.australia.basketball/about/national-integrity-framework"
                }
                if (form == 'COVID') {
                    return "https://basketballwa.asn.au/covid-19-return-to-sport-guidelines-information/"
                }
                if (form == 'T&Cs') {
                    return "https://basketballwa.asn.au/wp-content/uploads/2018/08/Item-TBC-ii.-BA-Member-Protection-Policy-Revised-June-2018-CLEAN.pdf"
                }
                if (form == 'Uniform') {
                    return 'https://basketballwa.asn.au/policies-forms/'
                }
                if (form == 'U16') {
                    return 'https://basketballwa.asn.au/policies-forms/'
                }
                break;
            // NBL1 Central
            case 3032:
                if (form == 'COC') {
                    return "https://basketballsa.com.au/wp-content/uploads/2021/09/Member-Protection-Codes-of-Conduct.pdf"
                }
                if (form == 'COVID') {
                    return "https://basketballsa.com.au/covid-19/"
                }
                if (form == 'T&Cs') {
                    return "https://basketballsa.com.au/policies-and-key-documents/"
                }
                if (form == 'Uniform') {
                    return 'https://basketballsa.com.au/policies-and-key-documents/'
                }
                if (form == 'U16') {
                    return 'https://basketballsa.com.au/policies-and-key-documents/'
                }
                break;
            default:
                break;
        }
    },

    // Load all Accreditations and Associations for each Conference
    LoadExtAccreds: (conf) => {
        PlayerAccred = 0, PlayerAccreds = [], StaffAccredids = [], OfficialAccredids = [], NBL1Associations = [], mediaAccred = 0
        switch (conf) {
            // NBL1 South
            case 3031:
                PlayerAccred = 7210
                StaffAccredids = [7211, 7212, 7213, 7214, 7221]
                OfficialAccredids = [7215, 7216, 7217, 7218, 7219, 7220, 7224]
                mediaAccred = 7222
                NBL1Associations = [
                    { Detail: "Ballarat", Code_id: 1455, Association: 1455 },
                    { Detail: "Bendigo", Code_id: 1457, Association: 1457 },
                    { Detail: "Casey", Code_id: 1462, Association: 1462 },
                    { Detail: "Dandenong", Code_id: 1468, Association: 1468 },
                    { Detail: "Diamond Valley", Code_id: 1469, Association: 1469 },
                    { Detail: "Eltham", Code_id: 1471, Association: 1471 },
                    { Detail: "Frankston", Code_id: 1472, Association: 1472 },
                    { Detail: "Geelong United", Code_id: 1473, Association: 1473 },
                    { Detail: "Hobart", Code_id: 3375, Association: 3375 },
                    { Detail: "Keilor", Code_id: 1477, Association: 1477 },
                    { Detail: "Kilsyth", Code_id: 1479, Association: 1479 },
                    { Detail: "Knox", Code_id: 1039, Association: 1039 },
                    { Detail: "Northern Force", Code_id: 3927, Association: 3927 },
                    { Detail: "Melbourne Tigers", Code_id: 3358, Association: 3358 },
                    { Detail: "Mt Gambier", Code_id: 3377, Association: 3377 },
                    { Detail: "Nunawading", Code_id: 1487, Association: 1487 },
                    { Detail: "NW Tasmania", Code_id: 3378, Association: 3378 },
                    { Detail: "Ringwood", Code_id: 1490, Association: 1490 },
                    { Detail: "Sandringham", Code_id: 1492, Association: 1492 },
                    { Detail: "Waverley", Code_id: 1500, Association: 1500 },
                    { Detail: "Not Listed", Code_id: 3397, Association: 3397 },
                ]
                Finals = 'Please also note that 9 games are required to be played to qualify for finals !'
                break;
            // NBL1 North
            case 3034:
                PlayerAccred = 7125
                StaffAccredids = [7126, 7127, 7128, 7129, 7136]
                OfficialAccredids = [7130, 7131, 7132, 7133, 7134, 7135, 7138]
                mediaAccred = 7137
                NBL1Associations = [
                    { Detail: "Brisbane", Code_id: 180, Association: 180 },
                    { Detail: "Cairns", Code_id: 183, Association: 183 },
                    { Detail: "Darwin", Code_id: 3062, Association: 3062 },
                    { Detail: "Gold Coast", Code_id: 185, Association: 185 },
                    { Detail: "Ipswich", Code_id: 186, Association: 186 },
                    { Detail: "Logan", Code_id: 176, Association: 176 },
                    { Detail: "Mackay", Code_id: 187, Association: 187 },
                    { Detail: "North Gold Coast", Code_id: 175, Association: 175 },
                    { Detail: "Northside", Code_id: 188, Association: 188 },
                    { Detail: "Red City", Code_id: 178, Association: 178 },
                    { Detail: "Rockhampton", Code_id: 189, Association: 189 },
                    { Detail: "South West Metro", Code_id: 177, Association: 177 },
                    { Detail: "Southern Districts", Code_id: 179, Association: 179 },
                    { Detail: "Sunshine Coast Phoenix", Code_id: 192, Association: 192 },
                    { Detail: "Townsville", Code_id: 194, Association: 194 },
                    { Detail: "USC Rip City", Code_id: 195, Association: 195 },
                ]
                Finals = 'Please also note that 9 games are required to be played to qualify for finals !'
                break;
            // NBL1 Central
            case 3032:
                PlayerAccred = 7195
                StaffAccredids = [7196, 7197, 7198, 7199, 7206]
                OfficialAccredids = [7200, 7201, 7202, 7203, 7204, 7205, 7209]
                mediaAccred = 7207
                NBL1Associations = [
                    { Detail: "Central District", Code_id: 1147, Association: 1147 },
                    { Detail: "Eastern Mavericks", Code_id: 1148, Association: 1148 },
                    { Detail: "Forestville", Code_id: 1149, Association: 1149 },
                    { Detail: "North Adelaide", Code_id: 1150, Association: 1150 },
                    { Detail: "Norwood", Code_id: 1151, Association: 1151 },
                    { Detail: "South Adelaide", Code_id: 1152, Association: 1152 },
                    { Detail: "Southern Tigers", Code_id: 1153, Association: 1153 },
                    { Detail: "Sturt Sabres", Code_id: 1154, Association: 1154 },
                    { Detail: "West Adelaide", Code_id: 1155, Association: 1155 },
                    { Detail: "Woodville", Code_id: 1156, Association: 1156 },
                    { Detail: "BSA No Association", Code_id: 2956, Association: 2956 },
                ]
                Finals = 'Please also note that 9 games are required to be played to qualify for finals !'
                break;
            // NBL1 West
            case 3033:
                PlayerAccred = 7225
                PlayerAccreds = [7225, 7240]
                // PlayerRoles = [1,29],
                StaffAccredids = [7226, 7227, 7228, 7229, 7236]
                OfficialAccredids = [7230, 7231, 7232, 7233, 7234, 7235, 7239]
                mediaAccred = 7237
                NBL1Associations = [
                    { Detail: "Cockburn", Code_id: 3455, Association: 3455 },
                    { Detail: "East Perth", Code_id: 3456, Association: 3456 },
                    { Detail: "Eastern Suns", Code_id: 3457, Association: 3457 },
                    { Detail: "Geraldton", Code_id: 3459, Association: 3459 },
                    { Detail: "Goldfields", Code_id: 3460, Association: 3460 },
                    { Detail: "Joondalup", Code_id: 3461, Association: 3461 },
                    { Detail: "Lakeside", Code_id: 3462, Association: 3462 },
                    { Detail: "Mandurah", Code_id: 3463, Association: 3463 },
                    { Detail: "Perry Lakes", Code_id: 3464, Association: 3464 },
                    { Detail: "Perth", Code_id: 3465, Association: 3465 },
                    { Detail: "Rockingham", Code_id: 3466, Association: 3466 },
                    { Detail: "South West", Code_id: 3467, Association: 3467 },
                    { Detail: "Warwick", Code_id: 3468, Association: 3468 },
                    { Detail: "Willetton", Code_id: 3469, Association: 3469 },
                    { Detail: "Association Not Listed", Code_id: 3476, Association: 3476 },
                ]
                Finals = "You must play a minimum 1/3 of the season to qualify for finals, 7 games for women, 8 games for men"
                break;
            // NBL1 East
            case 3060:
                PlayerAccred = 0
                StaffAccredids = []
                OfficialAccredids = []
                mediaAccred = 7140
                NBL1Associations = []
                Finals = 'Please also note that 9 games are required to be played to qualify for finals !'
                break;
            // NBL1 Media
            case 3452:
                PlayerAccred = 0
                StaffAccredids = []
                OfficialAccredids = []
                mediaAccred = 7139
                NBL1Associations = []
                Finals = 'Please also note that 9 games are required to be played to qualify for finals !'
                break;
            default:
                break;
        }
        return { PlayerAccred, PlayerAccreds, StaffAccredids, OfficialAccredids, NBL1Associations, Finals }
    },

    // Lookup Teams for each Conference
    LookupTeams: async (param) => {
        let SubCompetition = await functions.GetCodeBy({
            State_Champs: param.State_Champs,
            Type: 'Competitions',
            Gender: param.Gender
        }, true)
        param.State_Champs = SubCompetition[0].Code_id
        param.Type = "Teams"
        let Teams = await functions.GetCodeBy(param, true)
        return Teams
    },

    //Conference Details
    ConfDetails: [
        { Code_id: 3034, Name: 'NBL1 North', Organisation: 'Basketball Queensland', abbrev: 'BQ', logo: 'NBL1North.png' },
        { Code_id: 3060, Name: 'NBL1 East', Organisation: 'Basketball New South Wales', abbrev: 'BNSW', logo: 'NBL1East.png' },
        { Code_id: 3031, Name: 'NBL1 South', Organisation: 'Basketball Victoria', abbrev: 'BV', logo: 'NBL1South.png' },
        { Code_id: 3032, Name: 'NBL1 Central', Organisation: 'Basketball South Australia', abbrev: 'BSA', logo: 'NBL1Central.png' },
        { Code_id: 3033, Name: 'NBL1 West', Organisation: 'Basketball Western Australia', abbrev: 'BWA', logo: 'NBL1West.png' },
        { Code_id: 3452, Name: 'NBL1', Organisation: 'NBL1', abbrev: 'NBL1', logo: 'NBL1.png' },
    ],

    // Shirt Details
    LookupShirtSizes: async () => {
        // ShirtSizes = await functions.GetCodeBy({ Type: "Stats Shirt Sizes" }, true)
        // ShirtSizes.sort((a, b) => { return a.Code_id - b.Code_id });
        // return ShirtSizes
        return ['Size 2XS', 'Size XS', 'Size Small', 'Size Medium', 'Size Large', 'Size Extra Large',
            'Size 2XL', 'Size 3XL', 'Size 4XL', 'Size 5XL']
    },

    // General Variables
    CompType: ["Male Competition", "Female Competition"],
    PlayerRoles: ["GUARD", "FORWARD", "CENTER"],
    StaffRoles: ["Coach", "Assistant Coach", "Development Coach", "Team Manager", "Medical Staff"],
    StaffRoleids: [3, 9, 15, 10, 11],
    OfficialRoles: ["Referee", "Referee Coach", "ScoreBench", "Statistician", "Delegate", "Game Day", "Board Member"],
    OfficialRoleids: [6, 16, 13, 13, 13, 13, 27],
    ConfEndDate: '2024-08-18',
}